import { useMutation } from "react-query";
import http from "infra/http";

function useVincularAreaComum(tenantId: string, id: string) {
  return useMutation(
    (areaComumVinculadaId: string) => {
      return http.post(
        `/v1/tenants/${tenantId}/area-comum/${id}/vincular`,
        {areaComumVinculadaId}
      );
    },
    { retry: false }
  );
}

export default useVincularAreaComum;
